import React from 'react'
import styles from './styles'
import { css } from 'aphrodite'

const Icon = ({
  fillRound = 'rgb(0, 105, 180)',
  fillBasket = '#adadad',
  fillCross = '#fff',
  hasFiles
}) => {
  if (!hasFiles) {
    fillCross = '#fff'
    fillBasket = '#efefef'
    fillRound = '#efefef'
  }
  return (
    <div style={{ height: 48 }}>
      <svg
        fill={fillRound}
        height={20}
        viewBox="0 0 24 24"
        width="20"
        style={{
          position: 'absolute',
          right: 1,
          marginTop: 3,
          zIndex: 90
        }}
      >
        <path d="M0 0h24v24H0z" fill={fillCross} />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
      </svg>
      <svg
        className={css(styles.container)}
        style={{ fill: fillBasket }}
        viewBox={'-7.004 -2 38 38'}
      >
        <path
          d={
            'M24.615,10.711c-0.297-0.443-1.035-0.888-1.628-0.888L3.902,8.492l-0.74-2.368 c0-0.148-0.149-0.444-0.445-0.444L0.942,5.088c-0.295-0.147-0.74,0-0.887,0.444c-0.148,0.295,0,0.74,0.443,0.887l1.479,0.445 l0.74,2.515l2.959,10.208c0.211,0.771,0.66,1.408,1.243,1.865c-0.663,0.546-1.096,1.357-1.096,2.277 c0,1.629,1.331,2.961,2.959,2.961c1.627,0,2.96-1.332,2.96-2.961c0-0.54-0.157-1.042-0.414-1.479h5.711 c-0.258,0.438-0.414,0.939-0.414,1.479c0,1.629,1.332,2.961,2.959,2.961c1.628,0,2.96-1.332,2.96-2.961 c0-0.798-0.324-1.521-0.841-2.054c0.725-0.463,1.269-1.179,1.433-2.089l1.776-6.954C25.06,11.894,25.06,11.303,24.615,10.711 L24.615,10.711z M8.783,25.212c-0.888,0-1.479-0.593-1.479-1.481c0-0.887,0.591-1.479,1.479-1.479c0.74,0,1.479,0.593,1.479,1.479 C10.262,24.619,9.67,25.212,8.783,25.212z M19.584,25.212c-0.888,0-1.479-0.593-1.479-1.481c0-0.887,0.592-1.479,1.479-1.479 c0.889,0,1.479,0.593,1.479,1.479C21.063,24.619,20.471,25.212,19.584,25.212z M21.803,19.292c-0.124,0.75-0.785,1.362-1.604,1.548 c-0.2-0.044-0.404-0.068-0.615-0.068c-0.308,0-0.596,0.061-0.876,0.148H9.657c-0.277-0.088-0.567-0.148-0.874-0.148 c-0.07,0-0.134,0.017-0.202,0.021c-0.643-0.246-1.204-0.83-1.427-1.501l-2.663-9.173l18.347,1.332c0.296,0,0.442,0.148,0.591,0.295 c0.147,0.148,0.147,0.444,0.147,0.592L21.803,19.292L21.803,19.292z'
          }
        />
      </svg>
    </div>
  )
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/Basket/Icon/icon.js